import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import {
    Chart,
    Interval,
    Axis,
    Tooltip,
    Coordinate,
    Legend,
} from "bizcharts";
import DataSet from "@antv/data-set";
import DownloadButton from "../Common/DownloadButton";
import { Paper } from "@mui/material";

const DodgeBarChart = (props) => {
    const [data, setData] = useState([]);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setData(results.data);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    data.map(d => {
        if (d['Organic flag'] === 'Organic') {
            d['Organic'] = props.comparisonFilter === 0 ? d['% between LOQ and LL samples'] : d['% Above LL samples']
        } else {
            d['Conventional'] = props.comparisonFilter === 0 ? d['% between LOQ and LL samples'] : d['% Above LL samples']
        }
    })

    const ds = new DataSet();
    const dv = ds.createView().source(data.sort((a, b) => a['Food commodity'] > b['Food commodity'] ? 1 : -1));
    dv.transform({
        type: "fold",
        fields: ["Conventional", "Organic"],
        key: "type",
        value: "value"
    });

    const [canvas, setCanvas] = useState(undefined);

    return (
        <Box>
            <Box display='flex' justifyContent='space-between'>
                <p style={{ marginBottom: '1.1rem', fontFamily: 'Roboto Condensed, sans-serif', width: '100%' }}>Comparison of organic and conventional products</p>
                <DownloadButton canvas={canvas} fileName={'Chart'} csv={data} />
            </Box>
            <Chart
                height={300}
                data={dv}
                autoFit
                onGetG2Instance={chartInstance => {
                    setCanvas(chartInstance.canvas);
                }}
            >
                <Legend />
                <Coordinate transpose scale={[1, -1]} />
                <Axis
                    name="Food commodity"
                    label={{
                        offset: 12,
                        style: {
                            fontFamily: 'Roboto Condensed, sans-serif'
                        }
                    }}
                />
                <Axis label={{
                    formatter: (a) => {
                        return a + '%';
                    }
                }} name="value" position={"right"} />
                <Tooltip itemTpl={'<li style="padding: 10px 0" data-index={index}>'
                    + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                    + '{name}: {value}%'
                    + '</li>'} />
                <Interval
                    position="Food commodity*value"
                    color={['type', ['#246898', '#00A1C8']]}
                    adjust={[
                        {
                            type: "dodge",
                            marginRatio: 1 / 32
                        }
                    ]}
                />
            </Chart>
            <Box display='flex' justifyContent='center' mt={'2rem'} flexDirection={{ xs: 'column', sm: 'row' }}>
                <Paper style={{fontFamily:'Roboto Condensed, sans-serif'}} elevation={4} sx={{ margin: { xs: '15px', sm: '0 15px' }, padding: '0 1rem' }}>
                    <p style={{ marginBottom: '.5rem' }}><b>Copper Compounds</b></p>
                    <p>
                        <b>554</b> Quantified
                        <br />
                        <b>6</b> Above legal limit
                    </p>
                </Paper>
                <Paper style={{fontFamily:'Roboto Condensed, sans-serif'}} elevation={4} sx={{ margin: { xs: '15px', sm: '0 15px' }, padding: '0 1rem' }}>
                    <p style={{ marginBottom: '.5rem' }}><b>Chlorates </b></p>
                    <p>
                        <b>46</b> Quantified
                        <br />
                        <b>15</b> Above legal limit
                    </p>
                </Paper>
                <Paper style={{fontFamily:'Roboto Condensed, sans-serif'}} elevation={4} sx={{ margin: { xs: '15px', sm: '0 15px' }, padding: '0 1rem' }}>
                    <p style={{ marginBottom: '.5rem' }}><b>Chlorpyrifos</b></p>
                    <p>
                        <b>24</b> Quantified
                        <br />
                        <b>13</b> Above legal limit
                    </p>
                </Paper>
            </Box>
        </Box>
    );
}

export default DodgeBarChart;